import React from 'react';
import { NavLink } from 'react-router-dom';
const Us1_ele_sub = () => {
  return (
    <div className='fixed top-16 right-0 left-0 h-7 justify-items-stretch w-full content-center gap-4 overflow-x-scroll whitespace-nowrap scroll-smooth flex scrollbar-hide bg-cyan-400 items-center z-50 justify-evenly'>
      
      <NavLink to="/tutoring/learner/us1/us1_ele/us1_ele_art" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >Fine Arts</NavLink>     
      
      <NavLink to="/tutoring/learner/us1/us1_ele/us1_ele_ela" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >ELA</NavLink>
        <NavLink to="/tutoring/learner/us1/us1_ele/us1_ele_spa" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >Spanish</NavLink>
        <NavLink to="/tutoring/learner/us1/us1_ele/us1_ele_lib" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >Library</NavLink>    

      <NavLink to="/tutoring/learner/us1/us1_ele/us1_ele_mat" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >Math</NavLink>     
      
      <NavLink to="/tutoring/learner/us1/us1_ele/us1_ele_mus" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >Music</NavLink>
        <NavLink to="/tutoring/learner/us1/us1_ele/us1_ele_phy" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >Physical Education</NavLink>
        <NavLink to="/tutoring/learner/us1/us1_ele/us1_ele_rel" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >Religion</NavLink> 

      <NavLink to="/tutoring/learner/us1/us1_ele/us1_ele_sci" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >Science</NavLink>     
      
      <NavLink to="/tutoring/learner/us1/us1_ele/us1_ele_soc" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >Social Studies</NavLink>
        <NavLink to="/tutoring/learner/us1/us1_ele/us1_ele_tec" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >Technology</NavLink>
        
    </div>
  );
}

export default Us1_ele_sub;
